import { useState } from 'react'
import { Card, CardContent } from '@/components/ui/card'
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs'
import EditSuggestionsList, { EditSuggestion } from './SuggestionsPanel'

interface MinutaContentProps {
  shouldShowLoading: boolean
  editableHtml: string
  fullStyledHtml: string
  handleSave: (html: string, id_suggestion: string) => Promise<void>
  selectedIcon: string
  historySuggestions: EditSuggestion[]
}

export function MinutaContent({
  shouldShowLoading,
  editableHtml,
  fullStyledHtml,
  handleSave,
  selectedIcon,
  historySuggestions
}: MinutaContentProps) {
  const [tab, setTab] = useState<'contract' | 'suggestions'>('contract')

  if (shouldShowLoading) {
    return (
      <Card className="w-full max-w-4xl min-h-[600px] shadow-sm border-0 bg-white/80 backdrop-blur-sm">
        <CardContent className="flex items-center justify-center h-96">
          <div className="flex flex-col items-center gap-4">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
            <p className="text-slate-600 font-medium">Carregando contrato...</p>
          </div>
        </CardContent>
      </Card>
    )
  }

  return (
    <div className="w-full max-w-4xl">
      <Card className="shadow-sm border-0 bg-white/80 backdrop-blur-sm">
        <CardContent className="p-0">
          <Tabs value={tab} onValueChange={v => setTab(v as any)} className="w-full">
            {/* Header das abas (sticky) */}
            <div>
              <div className="flex items-center justify-between px-4 pt-3 pb-2">
                <TabsList className="grid grid-cols-2 w-full max-w-md">
                  <TabsTrigger value="contract">Contrato</TabsTrigger>
                  <TabsTrigger value="suggestions">Alterações</TabsTrigger>
                </TabsList>
              </div>
            </div>

            {/* CONTEÚDO: CONTRATO */}
            <TabsContent value="contract" className="p-6">
              <div className="relative">
                {/* Marca d’água/brand ao fundo */}
                <div
                  className="absolute inset-0 pointer-events-none z-0"
                  style={{
                    backgroundImage: `url(${selectedIcon})`,
                    backgroundRepeat: 'repeat',
                    backgroundSize: '100%',
                    opacity: 0.08
                  }}
                />
                <div className="relative z-10">
                  <div
                    className="contract-display prose max-w-none [&_*]:text-justify [&_*]:leading-7 [&_p]:mb-4 [&_li]:text-justify"
                    dangerouslySetInnerHTML={{ __html: fullStyledHtml }}
                  />
                </div>
              </div>
            </TabsContent>

            {/* CONTEÚDO: SUGESTÕES */}
            <TabsContent value="suggestions">
              <EditSuggestionsList
                suggestions={historySuggestions}
                editableHtml={editableHtml}
                handleSave={handleSave}
                fullStyledHtml={fullStyledHtml}
              />
            </TabsContent>
          </Tabs>
        </CardContent>
      </Card>
    </div>
  )
}
